import { render } from "./PerformanceChartWh3.vue?vue&type=template&id=f9a017ac&ts=true"
import script from "./PerformanceChartWh3.vue?vue&type=script&lang=ts"
export * from "./PerformanceChartWh3.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__